import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { Listing, EmployeeCardAddEdit, BiometricsaddEdit} from './Pages';

export const EmployeeRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={Listing}/>
        <Route exact path = {`${match.path}/employeeCardAddEdit/:id?`} component={EmployeeCardAddEdit} />
        <Route exact path = {`${match.path}/employeeBiometricAddEdit/:id?`} component={BiometricsaddEdit} />
    </Fragment>
)